// extracted by mini-css-extract-plugin
export default {"premium":"Il8QeGFs","mobile":"mobile","top":"cjp51f3j","media":"GnJxGXXf"};